(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/helpers/handlebarshelpers.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/helpers/handlebarshelpers.js');

'use strict';

if (svs.isServer) {
  registerHelpers(require('hbs'));
} else {
  registerHelpers(Handlebars);
}
function registerHelpers(hbs) {
  hbs.registerHelper('distributionHeader', (payout, options) => options.fn({
    hasIWinners: svs.numbergames.results_common.conditionals.isInternationalProduct(payout.productId)
  }));
  hbs.registerHelper('distributionTable', (payout, options) => {
    let tableBody = '';
    if (payout && Array.isArray(payout.distribution)) {
      const hasIWinners = svs.numbergames.results_common.conditionals.isInternationalProduct(payout.productId),
        distribution = [...payout.distribution];
      for (let i = 0, len = distribution.length; i < len; i++) {
        const level = distribution[i],
          dist = {
            name: level.name,
            winners: "".concat(svs.utils.format.Currency(level.winners), " st")
          };
        if (hasIWinners) {
          if (level.iWinners !== undefined) {
            dist.iWinners = "".concat(svs.utils.format.Currency(level.iWinners), " st");
          } else {
            dist.iWinners = ' - ';
          }
        }
        if (!isNaN(parseInt(level.amount, 10))) {
          dist.amount = "".concat(svs.utils.format.Currency(level.amount), " kr");
        } else {
          dist.amount = level.amount;
        }
        if (i === 0) {
          dist.first = true;
        }
        tableBody += options.fn(dist);
      }
    }
    return tableBody;
  });
}

 })(window);